import './App.css';
import { BrowserRouter} from 'react-router-dom'
// import Dashboard from './Dashboard/Dashboard';
import Home from './Components/Home/Home';
import { ToastContainer } from 'react-toastify';
import DownloadImages from "./Pages/Products/DownloadImages";
function App() {
  return (
    <>
        <BrowserRouter>
          <Home/>
          <ToastContainer/>
        </BrowserRouter>
    </>
  );
}

export default App;
